/**
 * Module for consuming, cacheing, and pooling datasource-manager end-points. Provides a Defer/Promise interface for handling repsonse and error events.
 * @name data-fetcher
 */
define('data-fetcher/data-fetcher',['require','exports','module','jquery','mem-storage/mem-storage','datasource-manager/datasource-manager','DataTransferObject/DataTransferObject','app-console/app-console'],function(require,exports,module){

	var $=require('jquery'),
		$MemStorage=require('mem-storage/mem-storage'),
		$DataSourceManager=require('datasource-manager/datasource-manager'),
		$DataTransferObject=require('DataTransferObject/DataTransferObject'),
		appConsole=require('app-console/app-console'),
		$Log = new appConsole({ns : "data-fetcher"});
	
	var catchTransforms = module.config().catchTransforms === true;

	function Response(text, xml, success, completed){
		this.text=text;
		this.xml=xml;
		this.success=success;
		this.completed=completed;		
	}

	function Request(requestKey, datasource, params, callback, refresh) {
		this.startTime = new Date();
		this.timeout=datasource.timeout * 1000;
		this.datasource=datasource;
		this.dataSourceName = datasource.name;
		this.params = params;
		this.namespace = datasource.getNamespace(params);
		this.requestKey=requestKey;
		this.callback=callback;
		this.refresh=!!refresh;
		this.retryRequested=false;
		this.response=null;
		this.proxy=datasource.proxy;
		this.method=datasource.method||null;
		// ajax params may contain parameters specific for SOAP
		if (datasource.HTTPHeaders) {
			this.headers = datasource.HTTPHeaders || null;
			if(datasource.HTTPHeaders.SOAPAction){
				this.messageBody = datasource.getPostBodyTemplate(params) || null;
			}
		}
	}

	Request.prototype={

		requestRetry : function(){
			this.retryRequested=true;
		},
		send : function(){
			var request=this,
				xmlHttpReq = createXHR(),
		 		func = getOnReadyStateChange(),
				i;

			request.url = request.datasource.getUrl(request.params);

			if(request.url!==null && func && isOnline()) {
				func.req = request;
				request.handler=func;
				request.xhr=func.xhr = xmlHttpReq;
				xmlHttpReq.readyState=0;

				runDTO(dto.request,this);
		    	xmlHttpReq.open(request.method || 'GET', request.proxy ? request.proxy + encodeURIComponent(request.url) : request.url,true);

				if (request.headers) {
					for (i in request.headers) {
						xmlHttpReq.setRequestHeader(i, request.headers[i]);
					}
				}

				// CLOSURE-LESS TO PREVENT MEMLEAK IN BB
				xmlHttpReq.onreadystatechange = func;
				xmlHttpReq.onabort = request.abort;
				request.setTimeout();

				xmlHttpReq.send(request.messageBody || null);
			} else {
				$Log.error("REQUEST CANCELED", "resolvedurl is null", request);
				request.returned(new Response(null, null, false, false));
			}
		},
		cancel : function(abort){
			this.handler.inUse=false;
			clearTimeout(this.handler.timeout);
			this.handler.timeout=null;
			if(!abort){
				this.returned(new Response(null, null, false, true));
				return;
			}
			this.xhr.aborted=true;
		},
		retry : function(){
			var xhr=this.xhr;
			this.aborted=false;
			xhr.readyState=0;
	    	xhr.open(this.method || 'GET', this.url,true);
			xhr.send(this.messageBody||null);
			this.setTimeout();
			
		},
		setTimeout : function(){
			var request=this;
			if(this.xhr){
				clearTimeout(this.handler.timeout);
				this.handler.timeout=setTimeout(function(){
					if(request.xhr.readyState!==4){
						request.cancel(true);
						request.xhr.abort();
					}
				},this.timeout);
			}
		},
		notify : function(){
			var record=reqs[this.requestKey];
			if(record){
				//console.log("request before notify",request)
				record.notify(this);
			};
		},

		tryTransform : !catchTransforms ? function(ret, res){
			var data  = this.datasource.transform(res,this,this.xhr);
			if(!data){
				data = null;
				ret.err  = new Error();
			}
			ret.data = data;
		} : function(ret, res){
			var data;
			try {
				data  = this.datasource.transform(res,this,this.xhr);
			} catch(err){
				data = null;
				ret.err  = err;
			}
			ret.data = data;
		},
		returned : function(res) {
			var data,
				datasource=this.datasource,
				req=this,
				requestKey=this.requestKey,
				record=reqs[requestKey],
				ret=req.response={ 
					data 	: null, 
					text 	: null, 
					dataSourceName: this.dataSourceName, 
					params 	: this.params, 
					refresh : this.refresh, 
					expired : false, 
					err 	: null,
					source 	: SERVER
				};

			runDTO(dto.response,this);
			if(res.success && (res.text!==null || res.xml))  {
				//transform and hydrate object
				this.tryTransform(ret, res);
				data = ret.data;
				if(data === null){
					if(ret.err){
						ret.err.message="parse error from transformer :: " + this.dataSourceName + " :: " + ret.err.message;
					}
					$Log.error("TRANSFORM FAILURE", ret.err, data, this.url);

					data=getNow(req);
					ret.expired=!data || !!data.expired;
					ret.data=data=data && data.value
					ret.source=CACHE_ERROR;
				}
				runDTO(dto.data,this);
				$MemStorage.put(this.namespace, getMemStorageKey(datasource,this.params), data, datasource.expires, datasource.priority);
				//send success
				$Log.log("SUCCESS", data, this.url);
			} else {
				data=getNow(req);
				ret.expired=!data || !!data.expired;
				ret.data=data=data && data.value
				ret.source=CACHE_ERROR;
				/* No data returned, or pulled from cache and req timeout */
				if(!data && !res.completed){
					this.notify();
					if(req.retryRequested){
						this.retryRequested=false;
						return;
					}
				}
				$Log.error("REQUEST FAILURE", res, data, this.url,this.xhr);
			}
			/* This shouldn't happen... but if no record is found, just give up */
			if(!record){
				return;
			}			
			delete reqs[requestKey];
			record[data ? RESOLVE : REJECT](ret);
		}
	};

	var CACHE_VALID		= "cache-valid",
		CACHE_ERROR 	= "cache-error",
		SERVER			= "server",
		RESOLVE 		= "resolve",
		REJECT 			= "reject",
		AMP				= "&",
		EQUAL			= "=",
		SEMI 			= ";",
		EMPTY           = "",
		POOLSIZE 		= 20,
		FUNCTION 		= "function",
		reqs={},
		regexstorage=/\{(\w+)(?:\:([^}]+))?\}/g,
		networkOnline=true,
		onReadyStateChangePool = [],
		dto = {
			request : [],
			response: [],
			data 	: []
		},

		runDTO = function(phase,context){
			var i=0,
				len=phase && phase.length||0;
			for (; i< len;i++){
				context=phase[i](context)||context;
			}
			return context;
		},

		createXHR = window.XMLHttpRequest ? function(){
			return new XMLHttpRequest();
		} : function(){
			return new ActiveXObject("Microsoft.XMLHTTP");
		},
		/**
		 * Default url filter used in generating request urls.
		 * Simply returns the supplied url.
		 *
		 * @param  {object} datasource  Datasource associated with url.
		 * @param  {string} url 		Url to modify.
		 * @return {string}	Modified url.
		 */
			defaultFilter = function(datasource,url){
			return url;
		},
	
		isOnline = function(){
			return navigator.onLine && networkOnline;
		},
		/**
		 * Convenience wrapper for retrieving a datasource from
		 * Curveball.Datasources by name.
		 *
		 * @private
		 *
		 * @param  {string} dataSourceName Name of the datasource to retrive.
		 * @return {object}	Curveball.Datasources.DataSource instance.
		 */
		getDatasource = function(dataSourceName) {
			return $DataSourceManager.get(dataSourceName);
		},
		/**
		 * Synchonous retrieval of a datasource from the storage cache.
		 * If no data is present, an empty StorageEntry will be returned.
		 * @note exposes internal method getNow.
		 *
		 * @private
		 *
		 * @see  Curveball.MemStorage.get
		 * @see  getNow
		 * @param  {object} req Datasource descriptor object.
		 * @return {mixed}		Curveball.Storage.StorageEntry instance or null.
		 */
		getNow = function(req) {
			var params= req.params,
				dataSourceName=req.dataSourceName,
				datasource=getDatasource(dataSourceName),
				obj = $MemStorage.get(
					datasource.getNamespace(params),
					getMemStorageKey(datasource,params)
				);

			if(obj && obj.value) {
				return obj;
			}
			return null;
		},
		/**
		 * Generate a unique key to store active requests
		 * during the request/response lifecycle.
		 *
		 * @private
		 *
		 * @param  {object} datasource Datasource object.
		 * @param  {object} params     Map of request variables.
		 * @param  {boolean} [refresh] True/Falsey indicator if request should be
		 *                             refreshed (no cached data).
		 * @return {string}            Generated request key;
		 */
		getRequestKey = function(datasource,params,refresh){
			return getMemStorageKey(datasource,params) + !!refresh;
		},
		/**
		 * Generate a storage key for use with the data cache.
		 * Should be unique to the datasource, it's params.

		 * @private
		 *
		 * @param  {object} datasource Instance of DataSource retrieved from
		 *                             Curveball.Datasources
		 * @param  {object} params     Map of request variables.
		 *
		 * @return {string}            Generated storage key.
		 */
		getMemStorageKey = function(datasource,params){
			var parString=EMPTY;

			datasource.getUrlTemplate().replace(regexstorage,function($0,$1,$2){
				parString+= (AMP + $1 + EQUAL + params[$1] || $2 || EMPTY) + SEMI;
			});

			return datasource.name + parString;
		},

		sharedOnReadyStateChange = function(func) {
			var xhr = func.xhr,
				req = func.req;

			if (xhr.readyState === 4) {
				networkOnline=true;
				clearTimeout(func.timeout);
				req.returned(new Response(xhr.responseText, xhr.responseXML, xhr.status===200||xhr.status===304,!xhr.aborted));
				func.inUse=false;
				func.timeout=null;
			}
		},

		  getOnReadyStateChange = function() {
		    var k = 0,
		      func;
		    for (; k < POOLSIZE; k++) {
		      func = onReadyStateChangePool[k];
		      if (!func.inUse) {
		        func.inUse = true;
		        return func;
		      }
		    }
		    return null;
		  };


	 /*
	  * Generate a wrapped state change pool of sixe POOLSIZE to monitor request states.
	  * These will be allocated at request time via Request.prototype.send.
	  * @see  Request.prototype.send;
	  */
 	(function(){
 		var i=0;
 		for(; i<POOLSIZE; i++) {
	 		onReadyStateChangePool[i]= function() {
		 		sharedOnReadyStateChange(arguments.callee);
		 	};
		}
	})();

		/* Public API */

	return {
		/**
		 * Clear the entire namespace related to a set of
		 * cached datasource responses.
		 * @param  {string} namespace Namespace to be cleared
		 * @see  Curveball.MemStorage.clearAll
		 * @return {object}		Returns Curveball.DataFetcher for chaining.
		 */
		clearNamespace : function(namespace) {
			$MemStorage.clearAll(namespace);
			return this;
		},
		/**
		 * @deprecated
		 * Sets the value of the internal url filter which is run
		 * at request time on all requested urls.
		 * @param {mixed} func 	Function to use as a filter.  Must return a properly formed
		 *                      url string.  Padding null or false restores the default filter.
		 * @return {object}		Returns Curveball.DataFetcher for chaining.
		 */
		setUrlFilter : function(func){
			return this;
		},
		/**
		 * Remove a specific datasource response cache.
		 * Once removed, response data is no longer accessible by
		 * any means.
		 *
		 * @note To retain data, while still flagging for an update
		 *       use Curveball.DataFetcher.expire
		 * @see Curveball.MemStorage.clear.
		 * @param  {object} req Descriptor object indicating the datasource
		 *                      and required params. @see Curveball.DataFetcher.get for format.
		 * @return {object}		Returns Curveball.DataFetcher for chaining.
		 */
		clearDataSource : function(req) {
			var datasource=getDatasource(req.dataSourceName),
				params= req.params;

			$MemStorage.clear(
				datasource.getNamespace(params),
				getMemStorageKey(datasource,params)
			)
			return this;
		},
		/**
		 * Set a datasource reponse to expired. This will trigger
		 * a server call on the next request.
		 * @note	The data will still be accessible via .getNow,
		 *       	or returned in the event that an update fails.
		 * @param  {[type]} req [description]
		 * @return {object}		Returns Curveball.DataFetcher for chaining.
		 */
		expire : function(req) {
			var datasource=getDatasource(req.dataSourceName),
				params= req.params;

			$MemStorage.expire(
				datasource.getNamespace(params),
				getMemStorageKey(datasource,params)
			)
			return this;
		},
		/**
		 * Take a peek at the current active/pooled requests.
		 * @return {object}		Returns Curveball.DataFetcher for chaining.
		 */
		peek : function(){
			return {
				reqs : reqs
			};
		},
		/**
		 * Synchonous retrieval of a datasource from the storage cache.
		 * If no data is present, an empty StorageEntry will be returned.
		 * @note exposes internal mehtod getNow.
		 *
		 * @see  Curveball.MemStorage.get
		 * @see  getNow
		 * @param  {object} req Datasource descriptor object.
		 * @return {object}		Response descriptor object.
		 */
		getNow: function(req){
			var obj=getNow(req);
			return  obj && obj.value && {
				data 	: obj.value,
				text 	: obj.value._text,
				dataSourceName: req.dataSourceName,
				params 	: req.params,
				source  : CACHE_VALID,
				refresh : req.refresh===true,
				expired : !!obj.expired
			}
		},
		/**
		 * Asynchronous call to a datasource endpoint as defined by
		 * Curveball.Datasources and matched by the descriptor object req.
		 * Outgoing connections are sent into a request pool to avoid redundant
		 * calls and cache entries.
		 *
		 * @param  {object} req Datasource descriptor object indicating a datasouce
		 *                      and request options.
		 * @example :
		 *          Curveball.DataFetcher.get({
		 *          		// Named datasource from Curveball.Datasources
		 *          	dataSourceName 	: {string},
		 *          		// Map of variables and replacement values
		 *          		// to be used in constructing the request url.
		 *          	params 			: {object},
		 *          		// Optional boolean to indicate a forced
		 *          		// refresh of data.  If:
		 *          		// 		true  -  this disregards the expiration state of cached data.
		 *          		// 		false/undefined - follows expiration policy.
		 *          	refresh 		: {boolean},
		 *          		// *Deprecated method of defining callback actions.
		 *          		// it is better to used the provided $.Deferred interface.
		 *          	callback 		: [{function}]  
		 *          });
		 *
		 * @uses   $.Deferred
		 * @return {object}		Promise object for attaching callback handlers.
		 */
		get : function(req) {
			var refresh=!!req.refresh,
				params=req.params,
				dataSourceName = req.dataSourceName,
				datasource=getDatasource(dataSourceName),
				requestKey=getRequestKey(datasource,params,refresh);

			// Return a promise object of the $.Deferred wrapped
			// request.  If a current request to this datasouce exists
			// piggy back off it to avoid wasted calls, and attach
			// your callbacks as required.
			return (reqs[requestKey] || $.Deferred(function(def){
				var obj = getNow(req);
				// console.log(req.dataSourceName,obj);
				if(!refresh && obj && (obj.expired !==1)) {
					// Valid cached data found.
					// Resolve the $.Deffered immediately.
					def.resolve({
						data 	: obj.value,
						text 	: obj.value._text,
						dataSourceName: dataSourceName,
						params 	: params,
						source  : CACHE_VALID,
						refresh : refresh,
						expired : !!obj.expired
					});
				} else {
					reqs[requestKey]=def;
					// console.trace(dataSourceName);
					(new Request(requestKey,datasource, params, req.callback,refresh)).send()
				}

			})).always(req.callback).promise();
		},
		put 		: function(req, xhr){
			var params=req.params,
				dataSourceName = req.dataSourceName,
				datasource=getDatasource(dataSourceName),
				dummyReq=new Request(getRequestKey(datasource,params,false),datasource, params, req.callback,false),
				dummyRes=new Response(xhr.responseText, xhr.responseXML, true, true);
			dummyReq.returned(dummyRes);
			// console.info("DataFetcher put : " + dataSourceName,dummyRes,getNow(req));
			return this;
		},

		registerDTO : function(dtoCandidate){
			var type;
			if(dtoCandidate instanceof $DTO) {
				for(type in dto){
					if(dtoCandidate.hasOwnProperty(type) && typeof dtoCandidate[type]===FUNCTION){
						dto[type].push(dtoCandidate[type]);
					}
				}			
			}			
		},
		Request : Request,
		Response: Response
	};
});
